import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '5af1bfae-15fb-4272-b8bb-5918d2894a80',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'ad607e27-1c7b-4911-8a8f-71044fe2911d',
      type: 'Container',
      name: 'leaderboardTextContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'e0a78612-afa2-47b0-bb83-efb95233e6e7',
      type: 'Container',
      name: 'score_0',
      className: '',
      x: 0,
      y: -240,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4',
      type: 'Container',
      name: 'score_1',
      className: '',
      x: 0,
      y: -180,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02',
      type: 'Container',
      name: 'score_2',
      className: '',
      x: 0,
      y: -120,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: '51a2b315-e918-440a-8883-9fbc44a7cc42',
      type: 'Container',
      name: 'score_3',
      className: '',
      x: 0,
      y: -60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'cf1d2ffd-4b1b-4836-afa1-464fcaa4a239',
      type: 'Container',
      name: 'score_4',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'ca7091ba-216f-46d8-92cc-de3f16224615',
      type: 'Container',
      name: 'score_5',
      className: '',
      x: 0,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'e170be53-bebd-4de1-b13c-dcd4e4ecad6f',
      type: 'Container',
      name: 'score_6',
      className: '',
      x: 0,
      y: 120,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'ab95de88-080e-4b10-97fe-4e9234cbad7a',
      type: 'Container',
      name: 'score_7',
      className: '',
      x: 0,
      y: 180,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'dd859fec-2af4-41af-bbcc-cd3d9f7af2e0',
      type: 'Container',
      name: 'score_8',
      className: '',
      x: 0,
      y: 240,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: '499c3e1d-3f52-45f8-be55-4e54da4984ee',
      type: 'Container',
      name: 'score_9',
      className: '',
      x: 0,
      y: 300,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: '8745d51d-5b68-4fcf-92b0-5decc8d799f9',
      type: 'Container',
      name: 'arrow_container',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: 'c428be00-e8b2-49cb-bb9e-647c2c048215',
      type: 'Sprite',
      name: 'continueButton',
      className: '',
      x: 0,
      y: 448.20000000000005,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Touch_To_Continue_Button',
      parent: '5af1bfae-15fb-4272-b8bb-5918d2894a80'
    },
    {
      id: '18885669-c9ed-485e-ba17-28a7199f0998',
      type: 'Sprite',
      name: 'trophy_decor',
      className: '',
      x: 0,
      y: -380,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'trophy_decor',
      parent: 'ad607e27-1c7b-4911-8a8f-71044fe2911d'
    },
    {
      id: '2e861a41-d4de-4314-af5b-4e3f6fcd5c47',
      type: 'Sprite',
      name: 'textRibbon',
      className: '',
      x: 0,
      y: -325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ribbon',
      parent: 'ad607e27-1c7b-4911-8a8f-71044fe2911d'
    },
    {
      id: '9e43b965-13e0-498e-a724-36b250adcb97',
      type: 'Text',
      name: 'leaderboardText',
      className: '',
      x: 0,
      y: -335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LEADERBOARD',
      localize: true,
      maxWidth: 420,
      maxHeight: 70,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: '#FFE431',
        stroke: 'black',
        strokeThickness: 3,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 420,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ad607e27-1c7b-4911-8a8f-71044fe2911d'
    },
    {
      id: 'e75f0004-a78f-4f7d-afb2-4ef311d6c0fd',
      type: 'Sprite',
      name: 'leaderboard_highlight_0',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight',
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: '0c2ac55e-b793-4a64-b914-b69c0822e103',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_0',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: 'de034320-1eb2-45e5-8a62-5130f92c6d6f',
      type: 'Sprite',
      name: 'score_trophy_0',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'trophy_1',
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: '261c689d-41d5-466d-a955-ff9c765fa1e0',
      type: 'Text',
      name: 'score_pos_0',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: '1141a62a-8f8a-4c24-ba89-cb0bd47d4e23',
      type: 'Text',
      name: 'score_name_0',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: '7a863d2c-ae4a-4183-bd3c-a6b2f0b937c9',
      type: 'Text',
      name: 'score_points_0',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e0a78612-afa2-47b0-bb83-efb95233e6e7'
    },
    {
      id: 'e57dc6a2-ab1f-428a-9c0a-d44ad81915de',
      type: 'Sprite',
      name: 'leaderboard_highlight_1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight',
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: 'd3722718-3ffc-4a94-9bfe-aa985484cef7',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: '282b0e4c-cc0e-47fb-aed3-8a1aa4788f06',
      type: 'Sprite',
      name: 'score_trophy_1',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'trophy_2',
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: '26b3b284-70ca-4ac3-85cd-2cdbb7a041e5',
      type: 'Text',
      name: 'score_pos_1',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: 'f9bb2da2-36b2-4027-9bc7-60098f820ec8',
      type: 'Text',
      name: 'score_name_1',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: '443f1b85-3f77-4438-a4ed-2d69189f0863',
      type: 'Text',
      name: 'score_points_1',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b66e6a92-6afc-4302-9eef-a71d2e1468e4'
    },
    {
      id: '2f4ab43a-bc3d-4190-8e40-9da406646ae8',
      type: 'Sprite',
      name: 'leaderboard_highlight_2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight',
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: '1a94cac0-7ad2-4d0e-9e40-f87debf26c6a',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: 'a1e6021a-7b02-42e0-9de9-357df7f35d9c',
      type: 'Sprite',
      name: 'score_trophy_2',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'trophy_3',
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: 'caff5d6a-49ee-44cb-a16d-46c4e44f6405',
      type: 'Text',
      name: 'score_pos_2',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: '4930a326-1b50-4322-8e84-b5a9e6aabbc1',
      type: 'Text',
      name: 'score_name_2',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: 'a768c3ba-45fc-4e01-ab17-acb8820c6ef1',
      type: 'Text',
      name: 'score_points_2',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4dfef93f-51cc-4677-bf09-e8b2b36bfa02'
    },
    {
      id: 'ac8d9d51-208b-4d02-87fd-0f5d86f927e4',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: '51a2b315-e918-440a-8883-9fbc44a7cc42'
    },
    {
      id: 'd304c5c6-da12-4f3c-8214-fa8c8b4686f8',
      type: 'Text',
      name: 'score_pos_3',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '4',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '51a2b315-e918-440a-8883-9fbc44a7cc42'
    },
    {
      id: 'cb0b29a8-e5ba-4562-89a9-1b4d0c675aab',
      type: 'Text',
      name: 'score_name_3',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '51a2b315-e918-440a-8883-9fbc44a7cc42'
    },
    {
      id: '01bdaa08-893d-4a3f-ba48-b565fcc0e83c',
      type: 'Text',
      name: 'score_points_3',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '51a2b315-e918-440a-8883-9fbc44a7cc42'
    },
    {
      id: '4a95472c-0a8c-45bc-942b-41eaddca49ac',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_4',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'cf1d2ffd-4b1b-4836-afa1-464fcaa4a239'
    },
    {
      id: 'fd33ae79-0763-4794-88b0-5ee47f841aea',
      type: 'Text',
      name: 'score_pos_4',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '5',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cf1d2ffd-4b1b-4836-afa1-464fcaa4a239'
    },
    {
      id: 'b9601d76-6fff-4865-9e10-3ec82d2f1da5',
      type: 'Text',
      name: 'score_name_4',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cf1d2ffd-4b1b-4836-afa1-464fcaa4a239'
    },
    {
      id: '06aa5647-8a17-4a96-98e1-795669fe908d',
      type: 'Text',
      name: 'score_points_4',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cf1d2ffd-4b1b-4836-afa1-464fcaa4a239'
    },
    {
      id: '4c023d15-9215-4aa1-9106-1fe134fa97b5',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_5',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'ca7091ba-216f-46d8-92cc-de3f16224615'
    },
    {
      id: '7f7df437-b3ad-4600-8f32-c14b0a3edeeb',
      type: 'Text',
      name: 'score_pos_5',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '6',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ca7091ba-216f-46d8-92cc-de3f16224615'
    },
    {
      id: '65e951ed-f778-4221-ad09-25629a64d130',
      type: 'Text',
      name: 'score_name_5',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ca7091ba-216f-46d8-92cc-de3f16224615'
    },
    {
      id: 'cad17e4f-6f34-4344-8743-182f57f1c2b4',
      type: 'Text',
      name: 'score_points_5',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ca7091ba-216f-46d8-92cc-de3f16224615'
    },
    {
      id: 'cda81c2c-5b22-4f32-944c-3d259ee27050',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_6',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'e170be53-bebd-4de1-b13c-dcd4e4ecad6f'
    },
    {
      id: '267d7f08-f380-4c46-b04b-b2a4620d1a7e',
      type: 'Text',
      name: 'score_pos_6',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '7',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e170be53-bebd-4de1-b13c-dcd4e4ecad6f'
    },
    {
      id: 'bf395020-dbb1-4bbd-9292-c0c351642f31',
      type: 'Text',
      name: 'score_name_6',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e170be53-bebd-4de1-b13c-dcd4e4ecad6f'
    },
    {
      id: '19cfef23-20b1-46f3-94e3-8465a06171f5',
      type: 'Text',
      name: 'score_points_6',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e170be53-bebd-4de1-b13c-dcd4e4ecad6f'
    },
    {
      id: '7b3bfcd7-ae7b-479c-8bf7-bbc8cbeb86d1',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_7',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'ab95de88-080e-4b10-97fe-4e9234cbad7a'
    },
    {
      id: 'f09e5119-afa0-4f93-b156-f45f1e507939',
      type: 'Text',
      name: 'score_pos_7',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '8',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ab95de88-080e-4b10-97fe-4e9234cbad7a'
    },
    {
      id: '242795c5-7121-4809-b979-dde98b72265a',
      type: 'Text',
      name: 'score_name_7',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ab95de88-080e-4b10-97fe-4e9234cbad7a'
    },
    {
      id: '0c62432c-24c5-4b37-a11e-95dd6c352035',
      type: 'Text',
      name: 'score_points_7',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ab95de88-080e-4b10-97fe-4e9234cbad7a'
    },
    {
      id: '99407fe6-a3e7-46fe-85f9-ba2262fb993f',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_8',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: 'dd859fec-2af4-41af-bbcc-cd3d9f7af2e0'
    },
    {
      id: '78974cd7-effc-4ecb-abb8-87a8ff3c9d52',
      type: 'Text',
      name: 'score_pos_8',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '9',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dd859fec-2af4-41af-bbcc-cd3d9f7af2e0'
    },
    {
      id: 'e7181e12-b563-477b-98e8-4795fd077de6',
      type: 'Text',
      name: 'score_name_8',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dd859fec-2af4-41af-bbcc-cd3d9f7af2e0'
    },
    {
      id: '677b128f-f4c6-4a50-a8f2-f4fcc25da2d5',
      type: 'Text',
      name: 'score_points_8',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dd859fec-2af4-41af-bbcc-cd3d9f7af2e0'
    },
    {
      id: '19c22c7a-1ebb-4728-8f43-3181da8bfec5',
      type: 'Sprite',
      name: 'leaderboard_highlight_CP_9',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'leaderboard_highlight_current_player',
      parent: '499c3e1d-3f52-45f8-be55-4e54da4984ee'
    },
    {
      id: 'a77555b7-f859-4ef4-8e8a-d47bfe32a59f',
      type: 'Text',
      name: 'score_pos_9',
      className: '',
      x: -265,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '499c3e1d-3f52-45f8-be55-4e54da4984ee'
    },
    {
      id: '7cc6219e-7f01-472f-8a52-c5830bafea93',
      type: 'Text',
      name: 'score_name_9',
      className: '',
      x: -115,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '499c3e1d-3f52-45f8-be55-4e54da4984ee'
    },
    {
      id: 'd777367a-121d-43f1-80a8-a575dabff3a0',
      type: 'Text',
      name: 'score_points_9',
      className: '',
      x: 290,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '%%%',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '499c3e1d-3f52-45f8-be55-4e54da4984ee'
    },
    {
      id: '37830a3d-993a-4647-8b7b-dc808f7611bf',
      type: 'Sprite',
      name: 'arrow_left',
      className: '',
      x: 200,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'winner_arrow',
      parent: '8745d51d-5b68-4fcf-92b0-5decc8d799f9'
    },
    {
      id: '6d3d4a57-a702-4646-b7de-a205d5562f5e',
      type: 'Sprite',
      name: 'arrow_right',
      className: '',
      x: 270,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'winner_arrow',
      parent: '8745d51d-5b68-4fcf-92b0-5decc8d799f9'
    },
    {
      id: 'c1b2e470-384c-4d01-8eeb-53f8329e69b7',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Continue',
      localize: true,
      maxWidth: 430,
      maxHeight: 80,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: '#276018',
        strokeThickness: 5,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 430,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'normal',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c428be00-e8b2-49cb-bb9e-647c2c048215'
    }
  ],
  x: 50,
  y: 50,
  width: 415,
  height: 647,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  leaderboardTextContainer: boolean;
  score_0: boolean;
  score_1: boolean;
  score_2: boolean;
  score_3: boolean;
  score_4: boolean;
  score_5: boolean;
  score_6: boolean;
  score_7: boolean;
  score_8: boolean;
  score_9: boolean;
  arrow_container: boolean;
  continueButton: boolean;
  trophy_decor: boolean;
  textRibbon: boolean;
  leaderboardText: boolean;
  leaderboard_highlight_0: boolean;
  leaderboard_highlight_CP_0: boolean;
  score_trophy_0: boolean;
  score_pos_0: boolean;
  score_name_0: boolean;
  score_points_0: boolean;
  leaderboard_highlight_1: boolean;
  leaderboard_highlight_CP_1: boolean;
  score_trophy_1: boolean;
  score_pos_1: boolean;
  score_name_1: boolean;
  score_points_1: boolean;
  leaderboard_highlight_2: boolean;
  leaderboard_highlight_CP_2: boolean;
  score_trophy_2: boolean;
  score_pos_2: boolean;
  score_name_2: boolean;
  score_points_2: boolean;
  leaderboard_highlight_CP_3: boolean;
  score_pos_3: boolean;
  score_name_3: boolean;
  score_points_3: boolean;
  leaderboard_highlight_CP_4: boolean;
  score_pos_4: boolean;
  score_name_4: boolean;
  score_points_4: boolean;
  leaderboard_highlight_CP_5: boolean;
  score_pos_5: boolean;
  score_name_5: boolean;
  score_points_5: boolean;
  leaderboard_highlight_CP_6: boolean;
  score_pos_6: boolean;
  score_name_6: boolean;
  score_points_6: boolean;
  leaderboard_highlight_CP_7: boolean;
  score_pos_7: boolean;
  score_name_7: boolean;
  score_points_7: boolean;
  leaderboard_highlight_CP_8: boolean;
  score_pos_8: boolean;
  score_name_8: boolean;
  score_points_8: boolean;
  leaderboard_highlight_CP_9: boolean;
  score_pos_9: boolean;
  score_name_9: boolean;
  score_points_9: boolean;
  arrow_left: boolean;
  arrow_right: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly leaderboardTextContainer: PIXI.Container;
  public readonly score_0: PIXI.Container;
  public readonly score_1: PIXI.Container;
  public readonly score_2: PIXI.Container;
  public readonly score_3: PIXI.Container;
  public readonly score_4: PIXI.Container;
  public readonly score_5: PIXI.Container;
  public readonly score_6: PIXI.Container;
  public readonly score_7: PIXI.Container;
  public readonly score_8: PIXI.Container;
  public readonly score_9: PIXI.Container;
  public readonly arrow_container: PIXI.Container;
  public readonly continueButton: PIXI.Sprite;
  public readonly trophy_decor: PIXI.Sprite;
  public readonly textRibbon: PIXI.Sprite;
  public readonly leaderboardText: PIXI.Text;
  public readonly leaderboard_highlight_0: PIXI.Sprite;
  public readonly leaderboard_highlight_CP_0: PIXI.Sprite;
  public readonly score_trophy_0: PIXI.Sprite;
  public readonly score_pos_0: PIXI.Text;
  public readonly score_name_0: PIXI.Text;
  public readonly score_points_0: PIXI.Text;
  public readonly leaderboard_highlight_1: PIXI.Sprite;
  public readonly leaderboard_highlight_CP_1: PIXI.Sprite;
  public readonly score_trophy_1: PIXI.Sprite;
  public readonly score_pos_1: PIXI.Text;
  public readonly score_name_1: PIXI.Text;
  public readonly score_points_1: PIXI.Text;
  public readonly leaderboard_highlight_2: PIXI.Sprite;
  public readonly leaderboard_highlight_CP_2: PIXI.Sprite;
  public readonly score_trophy_2: PIXI.Sprite;
  public readonly score_pos_2: PIXI.Text;
  public readonly score_name_2: PIXI.Text;
  public readonly score_points_2: PIXI.Text;
  public readonly leaderboard_highlight_CP_3: PIXI.Sprite;
  public readonly score_pos_3: PIXI.Text;
  public readonly score_name_3: PIXI.Text;
  public readonly score_points_3: PIXI.Text;
  public readonly leaderboard_highlight_CP_4: PIXI.Sprite;
  public readonly score_pos_4: PIXI.Text;
  public readonly score_name_4: PIXI.Text;
  public readonly score_points_4: PIXI.Text;
  public readonly leaderboard_highlight_CP_5: PIXI.Sprite;
  public readonly score_pos_5: PIXI.Text;
  public readonly score_name_5: PIXI.Text;
  public readonly score_points_5: PIXI.Text;
  public readonly leaderboard_highlight_CP_6: PIXI.Sprite;
  public readonly score_pos_6: PIXI.Text;
  public readonly score_name_6: PIXI.Text;
  public readonly score_points_6: PIXI.Text;
  public readonly leaderboard_highlight_CP_7: PIXI.Sprite;
  public readonly score_pos_7: PIXI.Text;
  public readonly score_name_7: PIXI.Text;
  public readonly score_points_7: PIXI.Text;
  public readonly leaderboard_highlight_CP_8: PIXI.Sprite;
  public readonly score_pos_8: PIXI.Text;
  public readonly score_name_8: PIXI.Text;
  public readonly score_points_8: PIXI.Text;
  public readonly leaderboard_highlight_CP_9: PIXI.Sprite;
  public readonly score_pos_9: PIXI.Text;
  public readonly score_name_9: PIXI.Text;
  public readonly score_points_9: PIXI.Text;
  public readonly arrow_left: PIXI.Sprite;
  public readonly arrow_right: PIXI.Sprite;


  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
